import { YearbudgetLimitComponent } from "../../../components/borrowSystem/Contact/YearbudgetLimitComponent"
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function YearbudgetLimitContainer () {
    const titleName = "แบบฟอร์มบันทึกข้อมูลผลการอนุมัติงบประมาณวงเงินให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem  />
            <HeadTitle title={titleName} />
            <YearbudgetLimitComponent/>
            <Footer />
        </div>   
    )
}